import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-courier-charges-form',
  templateUrl: './courier-charges-form.component.html',
  styleUrls: ['./courier-charges-form.component.css'],
})
export class CourierChargesFormComponent {
  url: string = 'configs';
  id!: string;
  form!: FormGroup;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Distance',
      route: '/logistics/fees',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Volume',
      route: '/logistics/fees/volume',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Weight',
      route: '/logistics/fees/weight',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      //desc: 'T2D Charges',
      desc: 'Runner',
      route: '/logistics/fees/task',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'Surcharges',
      route: '/logistics/fees/surcharges',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'EMM',
      route: '/logistics/fees/emm',
    }, */
  ];

  resumenCardsTwo = [
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Drivers',
      route: '/logistics',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Customers',
      route: '/logistics/customers',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Metrics',
      route: '/logistics/fees',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });

    this.form = this.fb.group({
      type: ['courier'],
      name: ['', [Validators.required]],
      code: ['', [Validators.required]],
      value: ['', [Validators.required]],
      status: [''],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      this.form.patchValue({
        name: response.name,
        code: response.code,
        value: response.value,
        status: response.status,
      });
    });
  }

  createData(): void {
    this.dataService
      .postData(`${this.url}/add`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('logistics/fees');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    //console.log('this.form.value',this.form.value);
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('logistics/fees');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  /* setCode() {
    const name = this.form.get('name')?.value;
    const code = name.replace(/\s+/g, '').toLowerCase();
    this.form.patchValue({
      code: code,
    });
  } */
}
